<template>
  <div>
    <a-modal
      title="添加任务"
      :visible="visible"
      :width="1000"
      ok-text="确认"
      cancel-text="取消"
      @ok="ok"
      @cancel="cancel"
    >
      <div>
        <div class="serch">
          <span>搜索:</span>
          <a-select
            placeholder="请选择项目"
            v-model="projectIds"
            @select="selectProject"
            default-value="0"
            style="margin-left: 16px; width: 200px"
          >
            <a-select-option value="0" key="0">全部项目</a-select-option>
            <a-select-option v-for="p in projectList" :key="p.id">
              {{ p.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <a-divider orientation="left"> 训练任务 </a-divider>
      <a-table
        :scroll="{ y: 360 }"
        :columns="columns"
        :showHeader="false"
        :data-source="data.list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          type: 'radio',
        }"
        rowKey="id"
        :pagination="pagination"
        @change="changePagination"
      >
        <div slot="type" slot-scope="text, record">
          <span> {{ record.projectName }} </span><br />
          <span> {{ record.networkModelName }} </span>
        </div>
        <div slot="bank" slot-scope="text, record">
          <span>资源库</span><br />
          <span> {{ record.resourceName }} </span>
        </div>
        <div slot="time" slot-scope="text, record">
          <span>完成时间</span><br />
          <span> {{ record.completeTime }} </span>
        </div>
      </a-table>
      <a-divider orientation="left"> 资源配置 </a-divider>
      <div class="info">
        <!-- <span>资源库:&nbsp;&nbsp;
          <a-select style="width:200px" :value="currentname" mode="multiple" @change="changeSelect" @deselect="delSelect">
            <a-select-option v-for="p in resource" :key="p.id">
              {{ p.name }}
            </a-select-option>
          </a-select>
        </span>
        <span>图片长度: {{ imgw }}</span>
        <span>图片宽度: {{ imgh }}</span> -->
        <a-form :form="form">
          <div class="formContent">
            <a-form-item label="资源库" style="display: flex">
              <a-select
                style="width: 300px; margin-right: 60px"
                mode="multiple"
                placeholder="请选择资源库"
                v-decorator="[
                  'pathIds',
                  { rules: [{ required: true, message: '请选择资源库' }] },
                ]"
              >
                <a-select-option
                  v-for="p in resource"
                  :key="p.name"
                  :value="p.name"
                >
                  {{ p.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="是否保持图片比例"
              style="display: flex; width: 340px"
            >
              <a-checkbox :checked="iskeepRatio" @change="changekeepRatio">
              </a-checkbox>
            </a-form-item>
          </div>

          <div class="formImage">
            <a-form-item label="image_width" style="display: flex">
              <a-input v-decorator="['imageWidth']" style="width: 300px" />
            </a-form-item>
            <a-form-item label="image_height" style="display: flex">
              <a-input v-decorator="['imageHeight']" style="width: 300px" />
            </a-form-item>
          </div>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { requestUrl } from "@utils/request_url";
import request from "@utils/request";
import pick from "lodash.pick";
const fields = ["imageHeight", "imageWidth"];
const columns = [
  {
    title: "Type",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
  },
  {
    title: "Bank",
    dataIndex: "bank",
    scopedSlots: { customRender: "bank" },
  },
  {
    title: "Time",
    dataIndex: "time",
    scopedSlots: { customRender: "time" },
  },
];
export default {
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    projectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns,
      selectedRowKeys: [],
      bank: null,
      imgw: null,
      imgh: null,
      checkId: null,
      resource: [],
      currentname: [],
      model: [],
      projectIds: "0",
      projectId: null,
      form: this.$form.createForm(this),
      iskeepRatio: false,
    };
  },
  created() {
    this.$watch("model", () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields));
    });
  },
  methods: {
    onSelectChange(key, values) {
      this.selectedRowKeys = key;
      // this.currentname = [];
      this.resource = [];
      this.loadConfig(key[0]).then((res) => {
        this.model = res.data;
        // this.currentname = res.data.pathIds;
      });
      this.projectId = values[0].projectId;
      this.loadResourceList(this.projectId).then((res) => {
        console.log(res);
        for (let i = 0; i < res.data.length; i++) {
          this.resource.push({
            id: res.data[i].id,
            name: res.data[i].name,
          });
        }
      });
    },
    changePagination(values) {
      this.$emit("changepage", values.current);
    },
    // changeSelect(value) {
    //   this.currentname.push(value[value.length - 1]);
    // },
    // delSelect(value) {
    //   for (let i = 0; i < this.currentname.length; i++) {
    //     if (this.currentname[i] == value) {
    //       this.currentname.splice(i, 1);
    //     }
    //   }
    // },
    async loadResourceList(id) {
      const resultData = [];
      const dataUrl =
        requestUrl + "/train/rest/test_file/get_test_resource_list/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },
    async loadConfig(id) {
      const resultData = null;
      const dataUrl = requestUrl + "/train/rest/task/get_task_config/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },
    ok() {
      var obj = {
        model: this.model,
        resource: this.resource,
        projectId: this.projectId,
      };
      this.form.validateFields((errors, values) => {
        console.log("111");
        if (!errors) {
          this.selectedRowKeys = [];
          this.$emit("ok", obj);
          this.projectIds = "0";
          this.iskeepRatio = false;
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      this.currentname = [];
      this.resource = [];
      this.selectedRowKeys = [];
      this.projectIds = "0";
      this.iskeepRatio = false;
    },
    selectProject(value) {
      this.$emit("selectTestProject", value);
    },
    changekeepRatio(value) {
      this.iskeepRatio = value.target.checked;
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  width: 100%;
}
.serch {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.formContent {
  display: flex;
  justify-content: space-around;
  padding: 0 100px 0 60px;
}
.formImage {
  display: flex;
  justify-content: space-around;
}
</style>